export default "__VITE_ASSET__ePGloXcY__"